import { Injectable } from "@angular/core";
import { HttpProvider } from "../../providers/http/http";
import { Chatroom } from "../../class/chatroom";

@Injectable()
export class WelcomeService {

  constructor(public http: HttpProvider) {
  }

  /**
   * （已catch）*/
  eventInit() {
    return this.http.hPost("/events_init");
  }

  getWelcomeDetail(id) {
    return this.http.hPost("/welcome/get_detail", { welcome_id: id });
  }

  getWelcomeList(page, pagesize,welcome_type?) {
    return this.http.hPost("/welcome/get_list", { page: page, pagesize: pagesize,welcome_type:welcome_type });
  }

  welcomeOperate(params) {
    return this.http.hPost("/welcome/operate", params);
  }

  /**
   * 新建活动 （已catch）*/
  createEvent(param) {
    return this.http.hPost("/events_create", param);
  }

  /**
   * 修改活动信息 （已catch）*/
  modifyEvent(param) {
    return this.http.hPost("/events_modify_v2", param);
  }

  /**
   * 验证群名可不可用 （已catch）*/
  validateStartName(param) {
    return this.http.hPost("/events_same_start_name", param);
  }

  /**
   * 获取拉新自动回复数据*/
  getAutoWordList(eventId) {
    return this.http.hPost("/events_auto_word_list", { event_id: eventId });
  }

  /**
   * 打开/关闭 大类的功能*/
  switchType(params) {
    return this.http.hPost("/events_switch_reply", params);
  }

  /**
   * 删除一条自动回复规则*/
  deleteRule(ruleId) {
    return this.http.hPost("/events_delete_reply", { id: ruleId });
  }

  /**
   * 编辑一条自动回复规则*/
  editReply(params) {
    params["is_work"] = true;
    // delete params.condition_num;
    return this.http.hPost("/events_edit_reply", params);
  }

  getWelcomeDisChatrooms(welcome_type?,event_id?){
    return this.http.hPost('/welcome/get_disabled_chatroom_list',{welcome_id:event_id,welcome_type:welcome_type})
  }

  deleteCondition(condition_id) {
    return this.http.hPost("/welcome/condition_delete", { condition_welcome_id: condition_id });
  }

  deleteWelcome(id, page, pagesize) {
    let params = {
      welcome_id: id,
      page: page,
      pagesize: pagesize
    };
    return this.http.hPost("/welcome/delete", params);
  }

  deleteWelcomeChatroom(welcome_id, chatroomname) {
    let params = {
      welcome_id: welcome_id,
      chatroomname: chatroomname
    };
    return this.http.hPost("/welcome/chatroom_delete", params);
  }

}

export interface WelcomeData {
  total_count?: number,
  welcome_info_list?: Array<MessageData>
}

export interface MessageData {
  chatroom_info_list?: Array<Chatroom>,
  chatroom_list?: Array<any>,
  condition_info_list?: object,
  condition_switch?: number,
  create_time?: number,
  message_list?: Array<any>,
  quantity_switch?: number,
  quantity_welcome_info?: object,
  time_switch?: number,
  time_welcome_info?: object,
  welcome_id?: string,
  welcome_message_info?: Array<any>,
  welcome_switch?: number,
  welcome_info_list?: Array<any>,
  welcome_type?:number,
  member_condition?:number,
  period?:number
}




// WEBPACK FOOTER //
// ./src/pages/welcome-ver2/welcome.service.ts